import React from 'react';
import { IAppliedFilter, EFilterFieldTypes } from '../filters';
import { EntityOwnerFilterDescription } from '../FilterFields/EntityOwnerFilter/EntityOwnerFilterDescription';

interface AppliedFilterDescriptionProps {
  filter: IAppliedFilter;
}

export const AppliedFilterDescription = ({
  filter,
}: AppliedFilterDescriptionProps) => {
  switch (filter.field.type) {
    case EFilterFieldTypes.owner:
      return <EntityOwnerFilterDescription filter={filter} />;

    default:
      return <span>{filter.field.displayName} is applied</span>;
  }
};
